import { Observable } from 'rxjs';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';



export abstract class BancoServiceVM {

    abstract getBancos(): Observable<BancoResponse[]>;
}
